var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Events")])]),_c('pagination-table',{attrs:{"items":_vm.events,"is-loading":_vm.isLoading,"fields":[
              {key: 'title'},
              {key: 'status'},
              {key: 'eventDate'},
              {key: 'actions'} ],"pagination":_vm.pagination,"item-url":"events/{id}"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }